import uiRouter from 'angular-ui-router';
import authenticationComponent from './authentication.component';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

let authenticationModule = angular.module('components.authentication', [
  uiRouter,
])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider
      .state(STATES.AUTHENTICATION, {
        url: ROUTES.AUTHENTICATION,
        component: 'authentication'
      });
  })

  .component('authentication', authenticationComponent)

  .name;

export default authenticationModule;



// WEBPACK FOOTER //
// ./client/app/features/authentication/authentication.js